import { render } from "./PsychologistDashboard.vue?vue&type=template&id=9469586e&scoped=true"
import script from "./PsychologistDashboard.vue?vue&type=script&lang=js"
export * from "./PsychologistDashboard.vue?vue&type=script&lang=js"

import "./PsychologistDashboard.vue?vue&type=style&index=0&id=9469586e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9469586e"]])

export default __exports__